import * as angular from 'angular';
import * as _ from 'lodash';
import { ComponentsModule } from '~/core-app/components';
import { SharedServicesModule } from '../mode-shared-services';
import { TableColumnSettings } from './table-settings/column-settings';
import { TableSettingsDirective } from './table-settings/table-settings';

export const DeprecatedDisplayTableModule = angular
  .module('mode.table', ['ngSanitize', ComponentsModule, SharedServicesModule])
  .constant('lodash', _)
  .component('tableColumnSettings', TableColumnSettings)
  .component('tableSettings', TableSettingsDirective).name;
